import { TableSettings } from "../../../../tableSettings";

export const fiscalYearSettingsTable: TableSettings = {
  tableVersion: 10041,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '221px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'white',
  columns: [
    { Header: '', accessor: 'indicator', resizable: true, sortable: false, visible: true, initialWidthPercentage: 6.98, },
    { Header: 'Fiscal Year', accessor: 'fyDesc', resizable: true, sortable: false, visible: true, initialWidthPercentage: 23.26, },
    { Header: 'Begin Date', accessor: 'beginDate', resizable: true, sortable: false, visible: true, initialWidthPercentage: 23.26, },
    { Header: 'End Date', accessor: 'endDate', resizable: true, sortable: false, visible: true, initialWidthPercentage: 23.26, },
    { Header: 'Year End', accessor: 'yearEnd', resizable: true, sortable: false, visible: true, initialWidthPercentage: 18.60, },
    { Header: '', accessor: 'scroll', resizable: false, sortable: false, visible: true, initialWidthPercentage: 4.64, },
  ]
};

export const yearEndHistoryTable: TableSettings = {
  tableVersion: 10041,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '120px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'white',
  columns: [
    { Header: '', accessor: 'indicator', resizable: true, sortable: false, visible: true, initialWidthPercentage: 6.98, },
    { Header: 'Date', accessor: 'date', resizable: true, sortable: false, visible: true, initialWidthPercentage: 27.92, },
    { Header: 'Fiscal Year', accessor: 'fyDesc', resizable: true, sortable: false, visible: true, initialWidthPercentage: 23.26, },
    { Header: 'Action', accessor: 'action', resizable: true, sortable: false, visible: true, initialWidthPercentage: 18.60, },
    { Header: 'User', accessor: 'user', resizable: true, sortable: false, visible: true, initialWidthPercentage: 18.60, },
    { Header: '', accessor: 'scroll', resizable: false, sortable: false, visible: true, initialWidthPercentage: 4.64, },
  ]
};

export const fiscalYearSettingsDetailsTable: TableSettings = {
  tableVersion: 10049,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '221px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'white',
  columns: [
    { Header: '', accessor: 'indicator', resizable: true, sortable: false, visible: true, initialWidthPercentage: 5, },
    { Header: 'Fiscal Year', accessor: 'fyDesc', resizable: true, sortable: false, visible: true, initialWidthPercentage: 13, },
    { Header: 'Begin Date', accessor: 'beginDate', resizable: true, sortable: false, visible: true, initialWidthPercentage: 16, },
    { Header: 'End Date #', accessor: 'endDate', resizable: true, sortable: false, visible: true, initialWidthPercentage: 16, },
    { Header: 'Year End', accessor: 'yearEnd', resizable: true, sortable: false, visible: true, initialWidthPercentage: 12, },
    { Header: 'Action', accessor: 'action', resizable: true, sortable: false, visible: true, initialWidthPercentage: 12, },
    { Header: 'Edit Date', accessor: 'u2Date', resizable: true, sortable: false, visible: true, initialWidthPercentage: 22.2, },
    { Header: '', accessor: 'scroll', resizable: false, sortable: false, visible: true, initialWidthPercentage: 3.8, },
  ]
};